/**
 * Created by Ning Jiang on 11/23/2016.
 */

import { Back, Ease, Elastic} from "gsap";

import { SanSymbolData } from "./engine/Symbol/SanSymbolData";

import { ILayersConfig } from "@nolimitcity/slot-game/bin/core/stage/ILayersConfig";
import { LayerScaleOption } from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";
import { IGameConfig } from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import { IDeviceDependentConfig } from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import { IReelEngineConfig } from "@nolimitcity/slot-game/bin/core/engines/reel/engine/IEngine";
import { IWinRatios } from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import { IGameTweakerConfig } from "@nolimitcity/slot-game/bin/dev/tweaker/GameTweaker";
import { GameConfig } from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { BetWinMode } from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import { SpinMode } from "@nolimitcity/slot-game/bin/core/gametype/SpinMode";
import { ISymbolStates } from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import { SymbolData } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/SymbolData";

export class SanGameConfig implements IGameConfig {

    public static instance:SanGameConfig = new SanGameConfig();

    BROWSER_FPS:number = 30;

    GAME_WIDTH:number = 1280;
    GAME_HEIGHT:number = 720;

    DEFAULT_LAYER_SCALE_OPTION:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {landscape : LayerScaleOption.FIT_WINDOW},
        mobile : {
            landscape : LayerScaleOption.FIT_WINDOW,
            portrait : LayerScaleOption.REELS_FIT_WINDOW
        }
    };

    // An controller for the Z-layers for created PIXI.containers. Managed by StageManager.
    LAYERS:ILayersConfig = {
        BACKGROUND : {
            name : "background",
            scaleOption : LayerScaleOption.FIT_WINDOW,
        },
        REEL : {name : "reel"},
        SYMBOLS : {name : "symbols"},
        REEL_OVERLAY : {name : "reel_overlay"},
        FEATURE : {name: "feature"},
        WIN_FRAMES : {name : "winFrames"},
        REEL_SUPER_OVERLAY : {name : "reel_super_overlay"},
        DARK_AREA : {name : "dark_area"},
        POSTER : {name : "poster"},
        FX_WIN : {name : "fx_Win"},
        WIN_COUNT_UP : {name : "winCountUp"},
        INTRO : {name : "introScreen"},
        BUTTON : {name : "button", scaleOption : LayerScaleOption.FIT_WINDOW},
        TWEAK_MODULE : {name : "tweakModule", scaleOption : LayerScaleOption.FIT_WINDOW},
        MINI_PAYTABLE : {name : "mini_paytable"},
        
        DEBUG : {name : "debug"}
    };
    
    // Define the Default symbol data in constructor.
    SYMBOL_DATA:SymbolData = new SanSymbolData({
        // Define what kind of texture it should try to find by standard process for linking to specified states.
        STATES : undefined,//[ ReelSymbolStates.NORMAL , ReelSymbolStates.SPIN, ReelSymbolStates.WIN  ],
        DIM:{
            WIDTH: 136,
            HEIGHT: 180,
            PADDING_X: 0,
            PADDING_Y: 0, 
            SCALE: new PIXI.Point(1,1),
        }
    });

    SPEED_FACTOR_SPIN:number = 1.3;

    // **  Reel Config ** //
    REEL_ENGINE_CONFIG:IReelEngineConfig = {
 
        // How many reels.
        REEL_AMOUNT:5,

        // What Container-layer will the Reels be placed.
        LAYER: this.LAYERS.REEL.name,

        // Default stepDistance. Usually the normal symbolSizeHeight.
        STEP_DISTANCE:180,

        // Standard Padding Between All Symbols.
        STEP_DISTANCE_PADDING_Y:0,
        // OverflowSymbols that will be displayed at Top. Minimum 1.
        OVERFLOW_TOP: 1,
        // How many symbols should be displayed as part of the winArea.
        WINDOW_AMOUNT:3,
        // OverflowSymbols that will be displayed at bottom. Minimum 1.
        OVERFLOW_BOTT:1,

        // OverflowOffset on Reeldata from server.
        RESULT_OVERFLOW:1,

        // REEL-Dimensions
        DIM:{
            PADDING_X:4,
            PADDING_Y:0,
            WIDTH: 136,
            HEIGHT: 180*3,
        },
        // FAST: GameSetting.Quickspin is true.
        // QUICK: Player triggers an QuickStop/QuickStart.

        // Define the duration for specific states.
        DURATION:{
            START:      0.4 / this.SPEED_FACTOR_SPIN,
            FAST_START: 0.3 / this.SPEED_FACTOR_SPIN,
            QUICK_START: 0.4 / this.SPEED_FACTOR_SPIN,
            SPIN:       0.08 / this.SPEED_FACTOR_SPIN, 
            STOP:       0.5 / this.SPEED_FACTOR_SPIN,
            FAST_STOP:  0.3 / this.SPEED_FACTOR_SPIN,
            QUICK_STOP: 0.25 / this.SPEED_FACTOR_SPIN,
            NEAR_WIN:   0.03 / this.SPEED_FACTOR_SPIN,
            SPIN_TIME:  2,
            QUICK_SPIN_TIME: 0,

            NUDGE: 1.6,
            EXPAND: 0.4,
        },
        // Define the delay for specific states.
        DELAY:{
            START:        0.08,
            FAST_START:   0.01,
            QUICK_START:  0.0,
            STOP:         0.15,
            FAST_STOP:    0.03,
            QUICK_STOP:   0.025,
        },
        // Define the Easeing for specific states.
        EASING:{
            START: Back.easeIn.config(1.6),
            QUICK_START: Elastic.easeIn.config(1.25,1),

            //"M0,0 C0.166,0.222 0.373,0.502 0.484,0.634 0.586,0.756 0.8,1 0.8,1 0.854,1.048 0.9,1 0.9,1 0.942,0.984 0.944,1 1,1"

            STOP: CustomEase.create("stop", "M0,0 C0.166,0.222 0.373,0.502 0.484,0.634 0.586,0.756 0.748,0.946 0.8,1 0.848,1.028 0.9,1 0.9,1 0.956,0.988 0.944,1 1,1"),
            // STOP: CustomEase.create("stop", "M0,0 C0.166,0.222 0.373,0.502 0.484,0.634 0.586,0.756 0.8,1 0.8,1 0.864,1.042 0.9,1 0.9,1 0.936,0.98 0.97,1 1,1"), //0.4
            // STOP: CustomEase.create("stop", "M0,0 C0.132,0.242 0.328,0.536 0.432,0.676 0.526,0.803 0.7,1 0.7,1 0.814,1.05 0.846,1 0.846,1 0.878,0.98 0.926,1 0.926,1 0.954,1.01 0.962,1 1,1 "),
            QUICK_STOP:  CustomEase.create("quick_stop", "M0,0 C0.132,0.242 0.328,0.536 0.432,0.676 0.526,0.803 0.7,1 0.7,1 0.814,1.05 0.846,1 0.846,1 0.878,0.98 0.926,1 0.926,1 0.954,1.01 0.962,1 1,1 "),// Elastic.easeOut.config(0.52, 0.32),
            EXPAND: Elastic.easeOut.config(1, 0.95), 
            NUDGE: CustomEase.create("nudge", "M0,0 C0,0 0.216,0.75 0.3,0.9 0.32,0.936 0.375,0.987 0.4,1 0.46,1.03 0.59,1.022 0.638,1 0.702,0.976 0.772,0.988 0.8,1 0.874,1.03 1,1 1,1"),
        }
    }
    
    REEL_ENGINE_POSITIONS:PIXI.Point[] = [
        // x, y = Size + (Padding * step)
        this.ReelPos( 0, 0), // 1
        this.ReelPos( 1, 0), // 2
        this.ReelPos( 2, 0), // 3
        this.ReelPos( 3, 0), // 4
        this.ReelPos( 4, 0), // 5
        this.ReelPos( 5, 0), // 6
    ];
 
    REEL_SETS:any = this.ReelSetCreation([ "BASE_REELSET", "BONUS_REELSET", "FREESPIN_REELSET", "RESPIN_REELSET", "FREESPIN_SETUP_REELSET"]);

    WIN_RATIOS:IWinRatios = {
        normalWin: [
            {
                ratio : 0,
                text : "Tiny Win",
                duration : 0,
            },
            {
                ratio : 1.5,
                text : "Small Win",
                duration : 0.3,
            },
            {
                ratio : 3,
                text : "Medium Win",
                duration : 0.8,
            },
            {
                ratio : 5,
                text : "Large Win",
                duration : 1.4,
            }
        ],
        bigWin : [
            {
                ratio : 15,
                text : "Big Win",
                duration : 4.530,
            },
            {
                ratio : 50,
                text : "Super Win",
                duration : 4.165,
            },
            {
                ratio : 100,
                text : "Mega Win",
                duration : 4.165,
            }, 
            {
                ratio : 250,
                text : "Epic Win",
                duration : 4.165,
            },
            {
                ratio : 1000,
                text : "Wicked Win",
                duration : 8.781,
            },
            {
                ratio : 2000,
                text : "Wicked Win",
                duration : 8.781,
            },
            {
                ratio : 5000,
                text : "Wicked Win",
                duration : 8.781,
            },
            {
                ratio : 50000,
                text : "Wicked Win",
                duration : 8.781,
            },
        ]
    };

    GAME_TWEAKER_CONFIG:IGameTweakerConfig = {
        layer : this.LAYERS.TWEAK_MODULE.name,
        baseWindowWidth : 400,
        moduleHeight : 32,
        copyAllButtonText : "Copy All",
        buttonSkinIdle : "button",
        buttonSkinOver : "button",
        buttonSkinDown : "button",
        buttonSkinDisabled : "button-disabled"
    };

    // #241
    WIN_BELOW_STAKE: boolean = false;
    private constructor() {
        if(SanGameConfig.instance) {
            throw new Error("GameConfig.constructor() - Instantiation failed: Singleton.");
        }
        GameConfig.gameConfig = this;
    }

    /* Helper  */
    private ReelPosX(step:number):number{
        return SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH * 0.5 + (this.REEL_ENGINE_CONFIG.DIM.PADDING_X + this.REEL_ENGINE_CONFIG.DIM.WIDTH) * step;
    }

    private ReelPosY(step:number):number{
        return SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * 0.5 + (this.REEL_ENGINE_CONFIG.DIM.PADDING_Y + this.REEL_ENGINE_CONFIG.DIM.HEIGHT)*step;
    }

    private ReelPos(stepX:number, stepY:number):PIXI.Point{
        return new PIXI.Point(this.ReelPosX(stepX), this.ReelPosY(stepY));
    }

    private ReelSetCreation(setType:string[]):any{
        const temp:any = {};
        for(let r:number = 0; r < setType.length ; r++){
            temp[setType[r]] = [];
            for(var i:number = 0; i < this.REEL_ENGINE_CONFIG.REEL_AMOUNT;i++){
                if(setType[r] === "FREESPIN_SETUP_REELSET"){
                    temp[setType[r]].push(insertSpecial(createBase(["X"], 35),["Z","Z","Z","Z","Z","Z","Z","Z"]));
                }else if(setType[r] === "FREESPIN_REELSET" || setType[r] === "BONUS_REELSET" || setType[r] === "RESPIN_REELSET"){
                    temp[setType[r]].push(insertSpecial(createBase(["M1", "M2", "M3", "M4", "M5","L1", "L2", "L3", "L4", "L5"], 125),["S"]));
                }
                else
                    temp[setType[r]].push(insertSpecial(createBase(["M1", "M2", "M3", "M4", "M5","L1", "L2", "L3", "L4", "L5"], 125),["W","S"]));
            }
        }

        function insertSpecial(arr:string[],types:string[]):string[]{
            for(let a:number = 0; a < types.length; a++){
                arr.splice(MathHelper.randomIntInRange(0,arr.length-1),0,types[a]);
            }
            return arr;
        }

        function createBase(types:string[],ammount:number):string[]{
            const temp:string[] = [];
            for(let a:number = 0; a < ammount ; a++){
                temp.push(types[MathHelper.randomIntInRange(0,types.length-1)])
            }
            return temp;
        }
        return  temp;
    }


    /* --------------  */
    SPIN_MODE: SpinMode;
    BET_WIN_MODE: BetWinMode = BetWinMode.BET_WAY;
    REEL_AREA_POS_X: number;
    REEL_AREA_POS_Y: number;
    REEL_AREA_WIDTH: number;
    REEL_AREA_HEIGHT: number;
    REEL_DISPLAY_POSITIONS= [];
    SYMBOLS_NUM_IN_REEL: [number, number, number, number, number];
    SYMBOL_STATES: ISymbolStates;
    SYMBOL_WIDTH: number;
    SYMBOL_HEIGHT: number;
    SYMBOL_BOTTOM_PADDING: number;
    REEL_SPIN_TIME: number;
    REEL_FAST_SPIN_SPIN_TIME: number;
    MIN_STOPPING_TIME?: number;
    REELS_NUM:number;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DURATION: number;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DELAY: number;
    REEL_SPIN_START_EASE: Ease;
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION: number;
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY: number;
    REEL_SPIN_STOP_ELASTIC_CONFIG: [number, number];
    REEL_SPIN_QUICK_STOP_ELASTIC_CONFIG: [number, number];
    REEL_SPIN_START_SPEED: number | number[];
    REEL_SPIN_SPIN_SPEED: number | number[];
    REEL_NEAR_WIN_SPIN_SPEED: number | number[];
    REEL_SPIN_STOP_SPEED: number | number[];
    REEL_SPIN_QUICK_STOP_SPEED: number | number[];
    REEL_STOP_DELAY: number | number[];
    REEL_QUICK_STOP_DELAY: number | number[];
    REEL_NEAR_WIN_STOP_DELAY: number | number[];
    NEW_BET_WHEN_ABORT_WIN_PRESENTATIONS: boolean;
}